import getCookieOverride from '../getCookieOverride';
import isInDev from '../isInDev';
import isOnServer from '../isOnServer';
import { Level, LevelPriority } from '../constants';
/**
 * Get the initial value of globalLogLevel. This code is in a function so that we may unit test it.
 * @private
 */

export var getInitialGlobalLogLevel = function getInitialGlobalLogLevel() {
  var isDev = isInDev();
  var globalLogLevel;
  var override = getCookieOverride();
  if (override) return override;

  if (isOnServer()) {
    // On the server
    if (isDev) {
      globalLogLevel = Level.debug; // everything will appear on the server console.
    } else {
      globalLogLevel = Level.log; // everything *other than* logger.debug will appear in the logs (elk).
    }
  } else {
    globalLogLevel = isDev ? Level.debug : Level.none;
  } // if an invalid logging level was specified, hide all output.
  // istanbul ignore if: We can't really test this.


  if (!LevelPriority[globalLogLevel]) {
    globalLogLevel = Level.none;
  }

  return globalLogLevel;
};
var globalLogLevel = getInitialGlobalLogLevel();
/**
 * This can be used to set logging programatically (Idea: Set logging level based on app-config).
 * @param level - The global logging level to be set. Once set, everything with a log level equal to
 *              or higher priority than the level supplied here will be logged. Everything else
 *              will be ignored.
 */

export var setLoggingLevel = function setLoggingLevel(level) {
  globalLogLevel = level;
};
/**
 * The current log level.
 */

export var getLoggingLevel = function getLoggingLevel() {
  return globalLogLevel;
};